import { ref } from 'vue'

const formatDate = date => {
  return new Date(date).toISOString().split('T')[0]
}

const ONE_DAY = 1
const DEFAULT_PERIOD = 30
const PERIOD_PLUS_ONE_DAY = DEFAULT_PERIOD + ONE_DAY
const TODAY = new Date()

const aggregationType = ref('daily')
const periodType = ref(DEFAULT_PERIOD)
const startDate = ref(formatDate(new Date().setDate(TODAY.getDate() - PERIOD_PLUS_ONE_DAY)))
const endDate = ref(formatDate(new Date().setDate(TODAY.getDate() - ONE_DAY)))
const defaultStartDate = ref(formatDate(new Date().setDate(TODAY.getDate() - PERIOD_PLUS_ONE_DAY)))
const defaultEndDate = ref(formatDate(new Date().setDate(TODAY.getDate() - ONE_DAY)))

export default function useConversionsData() {
  function changeStartDate(newStartDate) {
    let date = new Date()
    date = date - 1000 * 60 * 60 * 24 * 2

    if (new Date(newStartDate.value).getTime() > new Date(date).getTime()) {
      startDate.value = new Date(date).toISOString().split('T')[0]
    } else {
      startDate.value = newStartDate
    }
  }

  function changeEndDate(newEndDate) {
    let date = new Date()
    date = date - 1000 * 60 * 60 * 24
    if (new Date(newEndDate).getTime() > new Date(date).getTime()) {
      endDate.value = new Date(date).toISOString().split('T')[0]
    } else {
      endDate.value = newEndDate
    }
  }

  function changeAggregationType(type) {
    aggregationType.value = type
  }

  function changePeriodType(type) {
    periodType.value = Number(type)
    // periodType 0 means it's custom dates, so no need to calculate start and end date, the user has to select it manually.
    if (periodType.value == 0) return
    const newStartDate = new Date()
    newStartDate.setDate(newStartDate.getDate() - (periodType.value + 1))
    startDate.value = formatDate(newStartDate)
    const newEndDate = new Date()
    newEndDate.setDate(newEndDate.getDate() - 1)
    endDate.value = formatDate(newEndDate)
  }

  return {
    aggregationType,
    periodType,
    startDate,
    defaultStartDate,
    endDate,
    defaultEndDate,
    changeStartDate,
    changeEndDate,
    changePeriodType,
    changeAggregationType,
  }
}
